<template>
    <div>
        <div style="font-size: 18px; text-align: center; padding: 30px 0 10px 0;">设置支付密码</div>
        <div style="text-align: center; color: #888888; padding: 10px;">{{oldPaymentPassword === '' ? '请输入旧支付密码，用于验证支付密码' : (newPaymentPassword === '' ? '请设置新密码，用于新密码支付' : '请再次输入设置新支付密码，用于确认支付密码')}}</div>
        <van-password-input :value="password" :focused="showPaymentPasswordKeyboard" @focus="showPaymentPasswordKeyboard = true" />
        <van-number-keyboard v-model="password" :show="showPaymentPasswordKeyboard" :maxlength="6" />
    </div>
</template>

<script>
    import api from "../../assets/js/api";

    export default {
        name: "ModifyPaymentPassword",
        data(){
            return {
                password : '',
                showPaymentPasswordKeyboard : true,
                showPaymentPassword : false,
                oldPaymentPassword : '',
                newPaymentPassword : '',
                confirmPaymentPassword : '',
            };
        },
        watch : {
            password(newValue, oldValue){
                if(newValue.length >= 6){
                    let self = this;
                    if(this.oldPaymentPassword === ''){
                        this.oldPaymentPassword = newValue;
                        api.request('/user/check_payment_password', {
                            payment_password : this.oldPaymentPassword,
                        }).then(res => {}).catch(res => {
                            this.$notify({ type: 'danger', message: res.msg });
                            self.oldPaymentPassword = '';
                        }).finally(() => {
                            self.password = '';
                        });
                    }else if(this.oldPaymentPassword !== '' && this.newPaymentPassword === '' && this.confirmPaymentPassword === ''){
                        this.newPaymentPassword = newValue;
                        this.password = '';
                    }else if(this.oldPaymentPassword !== '' && this.newPaymentPassword !== '' && this.confirmPaymentPassword === ''){
                        this.confirmPaymentPassword = newValue;
                        if(this.newPaymentPassword !== this.confirmPaymentPassword){
                            this.password = this.newPaymentPassword = this.confirmPaymentPassword = '';
                            this.$notify({ type: 'danger', message: '两次输入的支付密码不一致，请重新输入' });
                        }else{
                            api.request('/user/modify_payment_password', {
                                old_payment_password : this.oldPaymentPassword,
                                new_payment_password : this.newPaymentPassword,
                                confirm_payment_password : this.confirmPaymentPassword,
                            }).then(res => {
                                self.$notify({ type: 'success', message: res.msg });
                                self.$router.back();
                            }).catch(res => {
                                self.$notify({ type: 'danger', message: res.msg });
                                self.password = self.oldPaymentPassword = self.newPaymentPassword = self.confirmPaymentPassword = '';
                            });
                        }
                    }
                }
            }
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/user/ModifyPaymentPassword.vue